// src/components/ChartConfig.js

export const getChartData = (data, regressionLine) => {
  return {
    labels: data.map(d => d.time.split(' ')[0]),
    datasets: [
      {
        label: 'Original Data',
        data: data.map(d => d.value),
        borderColor: 'blue',
        backgroundColor: 'blue',
        pointRadius: 5,
      },
      {
        label: 'LOESS smoothed line',
        data: regressionLine.map(d => d.y),
        borderColor: 'red',
        backgroundColor: 'transparent',
        borderDash: [5, 5],
        fill: false,
      },
    ],
  };
};

export const chartOptions = (unit = '', varLabel = 'Value') => ({
  responsive: true,
  plugins: {
    legend: { display: true },
    tooltip: {
      callbacks: {
        label: (context) => {
          const label = context.dataset.label || '';
          const value = context.parsed.y;
          return unit ? `${label}: ${value} ${unit}` : `${label}: ${value}`;
        }
      }
    }
  },
  scales: {
    x: { 
      title: { display: true, text: 'Time' }
    },
    y: { 
      title: { display: true, text: varLabel + (unit ? ` (${unit})` : '') }
    },
  },
});
